import React from 'react'
import { makeStyles, Text, tokens } from '@fluentui/react-components'
import { formatToSwedishCrowns } from '../../helpers/stringHelper'
import { Cost } from '../../api/schemas/schema'
import { t } from '../../i18n/i18n'

const useStyles = makeStyles({
   negativeValue: {
      color: tokens.colorStatusDangerBackground3,
   },
})

type DeviationSummaryProps = {
   costs?: Cost[]
   cost?: Cost
   size?: 100 | 200 | 300 | 400 | 500 | 600 | 700 | 800 | 900 | 1000
}

export const DeviationSummary = ({ costs, cost, size = 400 }: DeviationSummaryProps) => {
   const classes = useStyles()

   const value = costs
      ? costs.reduce<number | null>((sum, c) => {
           if (c.budget == null || c.result == null) return sum
           const d = c.budget - c.result
           return sum == null ? d : sum + d
        }, null)
      : cost && cost.budget != null && cost.result != null
      ? cost.budget - cost.result
      : null

   return value == null ? (
      <Text italic size={size}>
         {t('NoValueSet')}
      </Text>
   ) : (
      <Text size={size} className={value < 0 ? classes.negativeValue : ''}>
         {`${formatToSwedishCrowns(value)} kr`}
      </Text>
   )
}
